<template lang="html">
  <section
    id="footer"
    class="footer--container"
    v-if="$route.name != 'HistoriaInfografia'"
  >
    <newsletter v-if="$route.name != 'newsletter_thank'"></newsletter>

    <a href="#" v-scroll-to="'.nav'" class="subir"></a>

    <footer>
      <div class="container flex wrap justify-between align-center">
        <!-- <a class="show-redes" @click="toggleRedes">{{$t('footer.siguenos')}}</a> -->
        <div class="contact-footer">
          <p class="title">{{ $t("enlaces.textos.contacto") }}</p>
          <a :href="`mailto:${$t('contacto.email')}`">{{
            $t("contacto.email")
          }}</a>
          <a :href="`tel:${$t('contacto.phone')}`">{{
            $t("contacto.phone")
          }}</a>
          <ul class="flex row justify-start">
            <li>
              <a
                class="fa fa-youtube"
                href="https://www.youtube.com/channel/UCnoYVeFbsPiOVOcf80tW6Bg"
                target="_blank"
              ></a>
            </li>
            <li>
              <a
                class="fa fa-facebook"
                href="https://www.facebook.com/AjusaSpain/"
                target="_blank"
              ></a>
            </li>
<!--             <li>
              <a
                class="fa-brands fa-x-twitter"
                href="https://twitter.com/ajusa_spain"
                target="_blank"
              ></a>
            </li> -->
            <li>
              <a
                class="fa fa-instagram"
                href="https://www.instagram.com/ajusa_automotive/"
                target="_blank"
              ></a>
            </li>
            <li>
              <a
                class="fa fa-linkedin"
                href="https://www.linkedin.com/company/ajusa"
                target="_blank"
              ></a>
            </li>
          </ul>
        </div>
        <nav class="f-menu">
          <ul class="flex wrap justify-center">
            <li>
              <router-link
                :to="'/' + $i18n.locale + '/' + $t('enlaces.sala_prensa')"
                >{{ $t("enlaces.textos.sala_prensa") }}</router-link
              >
            </li>
            <li>
              <router-link
                :to="'/' + $i18n.locale + '/' + $t('enlaces.blog')"
                target="_blank"
                >{{ $t("enlaces.textos.blog")
                }}<i class="fa-regular fa-arrow-up-right-from-square"></i></router-link>
            </li>
            <li>
              <a href="http://www.ajusath.es/" target="_blank"
                >{{ $t("enlaces.textos.tecnologias_hidrogeno")
                }}<i class="fa-regular fa-arrow-up-right-from-square"></i></i
              ></a>
            </li>
            <li>
              <router-link
                :to="'/' + $i18n.locale + '/' + $t('enlaces.contacto')"
                >{{ $t("enlaces.textos.contacto") }}</router-link
              >
            </li>
            <li>
              <router-link
                target="_blank"
                :to="'/' + $i18n.locale + '/' + $t('enlaces.mapa_web')"
                >{{ $t("enlaces.textos.mapa_web") }}</router-link
              >
            </li>
          </ul>
          <ul class="flex wrap justify-center">
            <li>
              <router-link
                target="_blank"
                :to="$t('enlaces.condiciones_venta')"
                >{{ $t("enlaces.textos.condiciones_venta") }}</router-link
              >
            </li>
            <li>
              <router-link
                target="_blank"
                :to="'/' + $i18n.locale + '/' + $t('enlaces.politica')"
                >{{ $t("enlaces.textos.politica_privacidad") }}</router-link
              >
            </li>
            <li>
              <router-link
                target="_blank"
                :to="'/' + $i18n.locale + '/' + $t('enlaces.datos_seguros')"
                >{{ $t("enlaces.textos.datos_seguros") }}</router-link
              >
            </li>
            <li>
              <router-link
                target="_blank"
                :to="'/' + $i18n.locale + '/' + $t('enlaces.politica_cookies')"
                >{{ $t("enlaces.textos.politica_cookies") }}</router-link
              >
            </li>
            <li>
              <router-link
                target="_blank"
                :to="'/' + $i18n.locale + '/' + $t('enlaces.aviso_legal')"
                >{{ $t("enlaces.textos.aviso_legal") }}</router-link
              >
            </li>
          </ul>
        </nav>

        <div class="contenedor-cambio">
          <picture>
            <source media="(max-width: 900px)" srcset="/static/img/responsive/ajusa-certificados.webp">
            <img
            src="/static/img/ajusa-certificados.webp"
            class="imagen-certificados"
            :alt="$t('footer.alt_image')" width="800" height="432" loading="lazy" />
          </picture>
        </div>
      </div>

      <!-- <rrss-slide @toggle="toggleRedes" :show="show_redes"></rrss-slide> -->
    </footer>
  </section>
</template>

<script lang="js">

import Newsletter from '@/components/parts/newsletter';

import RRSS_slide from '@/components/view-parts/footer-parts/rrss-slide'
import Idioma from '@/components/view-parts/footer-parts/idioma'

import {mapGetters} from 'vuex';

export default  {
  name: 'app-footer',
  props: [],
  mounted() {

    $(window).scroll(function(event) {

      var distancia = $(window).scrollTop();

      if(distancia <= 1000){
        $(".subir").removeClass('fadeInUp');

        if($(".subir").hasClass('animated')){
          $(".subir").addClass('animated fadeOutDown');
        }

      }else{
        $(".subir").removeClass('animated fadeOutDown');
        $(".subir").addClass('animated fadeInUp');

      }


    });

/*     if(window.innerWidth < 900) {
      const ele = document.getElementById('footer');
      const images = ele.getElementsByTagName('img');
      for(var i=0; i < images.length; i++) {
        var src = images[i].src.replace('/static/img','/static/img/responsive');
        images[i].src = src;
      }
    } */
  },
  data() {
    return {
      show_redes : false,
      show_idioma : false,
    }
  },
  methods: {
    toggleRedes : function (){
      this.show_redes = !this.show_redes;
    },
    toggleIdioma : function (){
      this.show_idioma = !this.show_idioma;
    }
  },
  components :{
    'newsletter' : Newsletter,
    'rrss-slide' : RRSS_slide,
    'idioma' : Idioma
  }
}
</script>

<style scoped>
.imagen-certificados {
  width: 245px;
  height: auto;
  object-fit: contain;
}
footer {
  overflow: hidden;
}

.container {
  max-width: 1400px;
}
.f-menu {
  width: 68%;
}

.bandera {
  max-width: 40px;
  width: 100%;
  display: inline-block;
}

.contenedor-cambio {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
  -webkit-align-items: center;
}

.contenedor-cambio span {
  margin-right: 10px;
  height: 20px;
  line-height: 20px;
  text-transform: uppercase;
}

.contact-footer {
  display: flex;
  flex-direction: column;
}

.contact-footer a {
  margin-bottom: 10px;
  padding-right: 10px;
}

.contact-footer a:hover {
  color: #ffed00;
}

@media screen and (max-width: 1000px) {
  .container {
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
  }
  .f-menu {
    width: 100%;
  }

  .f-menu ul li {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .contact-footer {
    display: contents;
  }

  .contact-footer ul li a {
    font-size: 30px;
    margin: 15px;
  }
}

@media screen and (max-width: 500px) {
  .container {
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue